import createDataContext from './createDataContext';
import * as actions from './actions/systemInfoTemplateActions';
import { reducer, initialState } from './reducers/systemInfoTemplateReducer';

export const { Context: SystemInfoTemplateContext, Provider } = createDataContext(
  reducer,
  actions,
  initialState
);
